import { createSlice } from '@reduxjs/toolkit';

// Who is signed in on this browser, if anyone. `status` is 'unknown' until
// Firebase has said, then 'guest' or 'signedIn'.
const AccountSlice = createSlice({
    name: 'account',
    initialState: {
        status: 'unknown',
        profile: null,
        // The leaderboard-name dialog, after a first sign-in or from the menu.
        naming: false,
        busy: false
    },
    reducers: {
        setGuest: (state) => {
            state.status = 'guest';
            state.profile = null;
            state.naming = false;
            state.busy = false;
        },
        setProfile: (state, action) => {
            state.status = 'signedIn';
            state.profile = action.payload;
            state.busy = false;
        },
        setNaming: (state, action) => {
            state.naming = action.payload;
        },
        setBusy: (state, action) => {
            state.busy = action.payload;
        }
    }
});

export const { setGuest, setProfile, setNaming, setBusy } = AccountSlice.actions;
export const accountSelector = (state) => state.account;
export default AccountSlice.reducer;
